import React, { useContext, useState, useEffect } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import requests from '../utils/requests.js';
import Payment from './Payment.jsx';
import { s } from '../Style.jsx';
import functions from '../utils/functions.js';

const stripePromise = loadStripe('pk_live_51QIGmXAZSr0oWs0bnWsrriX3J1OwKZDWfMPNBBFr5R8xHWVKLWY7mHNznlzOnM7AohF91mHxsspTvGPRlSx9RcSP00C79xLmV9');

const Order = ({ initOrder, onClick, mini }) => {

    const { auth, user, cart, setCart, person, authorizing, orders, gettingOrders, setOrders, setGettingOrders } = useContext(PersonContext);
    const [error, setError] = useState();
    const [order, setOrder] = useState(initOrder);

    useEffect(() => {
        if (initOrder) return setOrder(initOrder);
        if (!gettingOrders && orders) {
            let viewId = window.location.search.split('view=')[1].split('&')[0];
            const order = orders.find(o => o.id === viewId);
            if (order) setOrder(order);
        }
    }, [orders, gettingOrders]);

    const [paying, setPaying] = useState();
    const [clientSecret, setClientSecret] = useState('');
    useEffect(() => {
        if (!paying || clientSecret) return;
        requests.stripeInitialize(auth, order.id).then(res => {
            setClientSecret(res.paymentIntent)
        });
    }, [paying]);

    const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const done = order?.dispatch_status === 'complete' || order?.dispatch_status === 'canceled';

    const Status = () => {

        const { title, icon } = (() => {

            if (order?.dispatch_status === 'canceled') return {
                title: 'Canceled',
                icon: 'fas fa-times',
            }

            if (order?.dispatch_status === 'complete') return {
                title: 'Order Complete',
                icon: 'fas fa-check',
            }

            if (order?.payment_status !== 'paid' && order?.stripeEnabled) return {
                title: 'Awaiting Payment',
                icon: 'fas fa-credit-card',
            }

            if (order?.dispatch_status === 'delivering') return {
                title: 'Out for Delivery',
                icon: 'fas fa-truck',
            }

            if (order?.dispatch_status === 'accepted') return {
                title: 'Driver Dispatched',
                icon: 'fas fa-truck',
            }

            if (order?.payment_status === 'paid' && order?.stripeEnabled) return {
                title: 'Paid',
                icon: 'fas fa-credit-card',
            }

            return {
                title: 'Under Review',
                icon: 'fas fa-spinner fa-spin',
            }

        })();

        return <div style={{ display: 'flex', width: 160, justifyContent: "flex-end", textAlign: "right", alignItems: 'center', marginTop: 4 }}>
            <span style={{ fontSize: 14 }} >{title}</span>
            <i style={{ marginLeft: 10 }} className={icon}></i>
        </div>;
    }

    const money = (n) => {
        if (typeof n === 'string') n = parseFloat(n);
        return n.toFixed(2);
    }

    const total = (subtotal, deliveryFee, deliveryFeeTax, stripeFee) => {
        let total = subtotal + deliveryFee + deliveryFeeTax + stripeFee;
        return total;
    }

    return <div>

        <div>
            {gettingOrders && <div style={s.loading}><i className="fas fa-spinner fa-spin"></i></div>}
            {(!gettingOrders && !order) && <>
                <div style={{ ...s.headerBox, marginBottom: 20 }}>
                    <div style={s.headerInnerBox}>

                        <h1 style={{ marginBottom: 0 }}><i className="fas fa-receipt"></i> Order Details</h1>

                    </div>
                </div>
                <div style={s.paddingContainer}>
                    <div style={s.mobileContainer}>
                        <i className={"fas fa-spinner fa-spin"}></i>
                    </div>
                </div>
            </>}
            {(!gettingOrders && order) && <>

                {mini && <div
                    onClick={() => onClick(order)}
                    style={{...s.orderBox, opacity: done ? 0.5 : 1 }}>

                    <div style={{ ...s.row, alignItems: "flex-start", justifyContent: "space-between" }}>
                        <div>
                            <h4 style={{ margin: 0 }}>Order #{order?.id}</h4>
                            <span style={{ fontSize: 14 }}>{order?.vendorName || order?.pickup?.split(',')[0]}</span>
                        </div>

                        <Status />
                    </div>

                    <div style={s.row}>
                        <h5 style={{ margin: 0, fontWeight: "bold" }}>${money(total(order?.subtotal, order?.deliveryFee, order?.deliveryFeeTax, order?.payment_status === "paid" ? order?.stripeFee || 0 : 0))}</h5>
                        <span style={{ fontSize: 14 }}>{month[new Date(order?.date).getMonth()]} {new Date(order?.date).getDate()}</span>
                    </div>

                </div>}

                {!mini && <>
                    <div style={{ ...s.headerBox, marginBottom: 20 }}>
                        <div style={s.headerInnerBox}>
                            <div>
                                <h1 style={{ marginBottom: 0 }}><i className="fas fa-receipt"></i> Order Details</h1>
                                <div style={{ ...s.row, maxWidth: 500 }}>
                                    <span style={{ fontSize: 14 }}>Order #{order?.id}</span>
                                    <Status />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={s.paddingContainer}>
                        <div style={s.mobileContainer}>

                            {order.vendorName && <h3 style={{ marginBottom: 10 }}>{order.vendorName}</h3>}

                            {(!paying || !clientSecret || !stripePromise) && !!order?.items?.length && <div style={s.box}>
                                <div style={{ ...s.table, marginBottom: 0 }}>
                                    {order.items.map((item, i) => <div style={s.cell(i)} key={i}>
                                        <div style={{ width: "100%", padding: "0 10px 4px" }}>
                                            {item.snapshot && <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "10px 0", justifyContent: "flex-end", width: "100%" }}>
                                                <span style={{ flex: 1, fontSize: 16 }}>{item.snapshot?.name}</span>
                                                <span>{item.quantity}</span>
                                                <span style={{ width: 60, fontWeight: "bold", textAlign: "right" }}>${money(item.total)}</span>
                                            </div>}
                                            {(!!item.combo?.items?.length || !!item.options?.length) && <div style={{ margin: "10px 0" }}>
                                                <div>
                                                    {item.combo && item.combo.items.map((comboItem, j) => <div style={{ width: "100%", textAlign: "right" }} key={j}>
                                                        <span style={{ fontSize: 14 }}>{comboItem.snapshot?.name}</span>
                                                    </div>)}
                                                </div>
                                                <div>
                                                    {item.options && item.options.map((option, j) => <div style={{ width: "100%", textAlign: "right" }} key={j}>
                                                        <span style={{ fontSize: 14 }}>{option.snapshot?.name}</span>
                                                    </div>)}
                                                </div>
                                            </div>}
                                            {item.notes && <span style={{
                                                boxShadow: item.snapshot ? "inset 0 10px 4px -10px #00000050" : "none",
                                                borderTop: item.snapshot ? "1px solid #00000050" : "none",
                                                margin: "0 0 6px 0", display: "block", fontSize: 14, paddingTop: 10,
                                            }}>{item.notes}</span>}
                                        </div>
                                    </div>)}
                                </div>
                            </div>}

                            {(!paying || !clientSecret || !stripePromise) && !!order?.notes && <>

                                <h3 style={{ marginBottom: 10 }}>Instructions</h3>
                                <span style={{ fontSize: 14, backgroundColor: "#fff", display: "block", marginBottom: 10 }}>{order?.notes}</span>

                            </>}

                            <h3 style={{ marginBottom: 10 }}>Order Summary</h3>
                            <div style={s.box}>
                                <div style={{ ...s.table, marginBottom: 0 }}>
                                    <div style={s.cell(0)}>
                                        <span style={{ fontSize: 14 }}>Subtotal</span>
                                        <span style={{ fontSize: 14 }}>${functions.formatMoney(order?.subtotal)}</span>
                                    </div>
                                    <div style={s.cell(1)}>
                                        <span style={{ fontSize: 14 }}>Delivery Fee</span>
                                        <span style={{ fontSize: 14 }}>${functions.formatMoney(order?.deliveryFee)}</span>
                                    </div>
                                    <div style={s.cell(0)}>
                                        <span style={{ fontSize: 14 }}>Tax</span>
                                        <span style={{ fontSize: 14 }}>${functions.formatMoney((order?.deliveryFeeTax) * 0.13)}</span>
                                    </div>
                                    {(order.payment_status === "paid" || paying) && !!order?.stripeFee && <div style={s.cell(1)}>
                                        <span style={{ fontSize: 14 }}>Transaction Fee</span>
                                        <span style={{ fontSize: 14 }}>${functions.formatMoney(order?.stripeFee)}</span>
                                    </div>}
                                    <div style={s.cell((order.payment_status === "paid" || paying) && !!order?.stripeFee ? 0 : 1)}>
                                        <span style={{ fontSize: 14 }}>Total</span>
                                        <h3 style={{ margin: "10px 0", fontSize: 18 }}>${functions.formatMoney(total(order?.subtotal, order?.deliveryFee, order?.deliveryFeeTax, paying || order.payment_status === "paid" ? order?.stripeFee || 0 : 0))}</h3>
                                    </div>
                                </div>
                            </div>

                            <div style={{ flexDirection: "row-reverse", display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                                {paying && (!clientSecret || !stripePromise) && <div style={{ padding: 10, fontSize: 14 }}><i className="fas fa-spinner fa-spin"></i></div>}
                                {order?.stripeEnabled && order?.payment_status !== 'paid' && !paying && <button
                                    style={s.bigButton}
                                    onClick={() => setPaying(true)}>Pay Now</button>}
                            </div>

                            {paying && clientSecret && stripePromise && order.payment_status !== "paid" && (
                                <Elements stripe={stripePromise} options={{ clientSecret }}>
                                    <Payment
                                        auth={auth} setOrders={setOrders} onComplete={async result => {
                                            setGettingOrders(true);
                                        }}
                                        setError={setError} order={order} setPaying={setPaying} />
                                </Elements>
                            )}

                            {(!paying || !clientSecret || !stripePromise) && <>
                                <h3 style={{ marginBottom: 10 }}>Delivery Details</h3>
                                <div style={s.box}>
                                    <div style={{ ...s.table, marginBottom: 0 }}>
                                        <div style={s.cell(0)}>
                                            <span style={{ fontSize: 14 }}>Pickup Address</span>
                                            <span style={{ fontSize: 14 }}>{order.vendorName || order?.pickup?.split(',')[0]}</span>
                                        </div>
                                        <div style={s.cell(1)}>
                                            <span style={{ fontSize: 14 }}>Delivery Address</span>
                                            <span style={{ fontSize: 14 }}>{order?.address?.split(',')[0]}</span>
                                        </div>
                                    </div>
                                </div>

                                <span style={{ fontSize: 14, textAlign: "right", display: "block", marginTop: 20 }}>{month[new Date(order?.date).getMonth()]} {new Date(order?.date).getDate()}</span>
                            </>}

                        </div>

                    </div>
                </>}

            </>}
        </div>

    </div >;
}
export default Order;
